"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../components/Button"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FormActions = react_1.memo(function (_a) {
    var canPublish = _a.canPublish, canSave = _a.canSave, onPreview = _a.onPreview, onPublish = _a.onPublish, onSave = _a.onSave, onReset = _a.onReset, canPreview = _a.canPreview;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.action_buttons },
        react_1.default.createElement("div", { className: "buttons-wrap" },
            react_1.default.createElement(Button_1.default, { variant: "outline", onClick: function (e) {
                    e.preventDefault();
                    onPreview();
                }, disabled: !canPreview }, t('POST_SCREEN.PREVIEW')),
            react_1.default.createElement(Button_1.default, { variant: canPublish ? 'outline' : 'primary', className: "text-center", disabled: !canSave, onClick: onSave }, t('POST_SCREEN.SAVE')),
            canPublish && (react_1.default.createElement(Button_1.default, { className: "text-center", onClick: onPublish }, t('POST_SCREEN.PUBLISH'))),
            react_1.default.createElement("span", { className: styles_module_scss_1.default.cancel_btn },
                react_1.default.createElement("a", { href: "#", onClick: function (e) {
                        e.preventDefault();
                        onReset();
                    } }, t('POST_SCREEN.RESET'))))));
});
exports.default = FormActions;
